import styled from 'styled-components';

export const DescriptonCTA = styled.div`
  padding: 30px 0;
  background: #ebebeb;

  @media (max-width: 575.98px) {
    text-align: center;
    padding-top: 0px;
    background: #f7f7f7;

    .btn_eventcta {
      margin-bottom: 1.5rem;
    }
  }
`;
export const ButtonFlex = styled.div`
  display: flex;
  justify-content: ${({ dir }) => (dir === 'rtl' ? 'start' : 'flex-end')};

  @media (max-width: 575.98px) {
    .btn_eventcta {
      margin-bottom: 1.5rem;
    }

    flex-flow: column;

    .event_sociallink {
      margin: 0px;
    }
  }

  &.eventwebdesc {
    @media (max-width: 767px) {
      justify-content: flex-start;
    }
  }
`;

export const SocialMediaLinks = styled.div`
  margin-left: 2rem;
  align-items: center;
  display: flex;
  .event_sociallink {
    margin: ${({ dir }) => (dir === 'rtl' ? '0 2rem 0 0' : '')};
    @media (max-width: 575.98px) {
      margin: 0px !important;
    }
  }

  p {
    color: #000;
    text-transform: uppercase;
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '10px')};
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '2.18px')};
    margin: ${({ dir }) => (dir === 'rtl' ? '5px 0 0 13px' : '5px 13px 0 0')};
  }

  @media (max-width: 575.98px) {
    margin: 14px auto 0;
  }
`;

export const WebSiteEvent = styled.div``;
